class BrixForm {
  static init(...parameters) {
    return new BrixForm(...parameters);
  }

  constructor(block) {
    if (block) {
      this.block = block;

      this.setupFocusListeners();
    }
  }

  setupFocusListeners() {
    const inputs = this.block.querySelectorAll('input');

    [...inputs].forEach((input) => {
      input.addEventListener('focus', () => {
        input.parentElement.previousElementSibling.classList.add('-hidden');
      });

      input.addEventListener('blur', () => {
        if (input.value.length === 0) {
          input.parentElement.previousElementSibling.classList.remove('-hidden');
        }
      });
    });
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-form', BrixForm.init);
}
